export default __webpack_public_path__ + "static/media/robotLogo.285075df.png";